module.exports = __webpack_public_path__ + "img/mockup_final.49b63404.png";